module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1503-74c406c34f23c8f627da58510f104c4e.png";